export default {
    url : 'https://pv9hv3qhml.execute-api.ca-central-1.amazonaws.com/dev'
}